import { EventStateStatus } from '@nv/components'
import { isAdmin } from '@nv/utils'
import { getEventStateStatus } from '@nv/utils'
import VotedStatus from '../voted_status/VotedStatus'
import styles from './EventStatus.module.scss'

const EventStatus = ({ eventState, votingOpen, hasVoted }) => {
  return (
    <div className={styles['container']}>
      <EventStateStatus eventStatus={getEventStateStatus(eventState, votingOpen)} />

      <div className={styles['body']}>{!isAdmin() && <VotedStatus hasVoted={hasVoted} />}</div>
    </div>
  )
}

export default EventStatus
